import React, { useState, useRef, useEffect } from "react";
import { IoSearch } from "react-icons/io5";
import Fuse from "fuse.js";

const Dropdown = ({
  style,
  items = [],
  assigned = [],
  labelKey = "username",
  placeholder = "Search...",
  title = "Select Item",
  assignedDrop = () => {},
  idPrefix = "item",
  fuseKeys = ["username"], // keys used for fuzzy search
}) => {
  const [dropOpen, setDropOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredItems, setFilteredItems] = useState(items);

  const searchInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const [fuseInstance, setFuseInstance] = useState(null);

  // Initialize Fuse.js when items or fuseKeys change
  useEffect(() => {
    if (items && items.length > 0 && fuseKeys.length > 0) {
      const fuse = new Fuse(items, {
        keys: fuseKeys,
        threshold: 0.4,
      });
      setFuseInstance(fuse);
      setFilteredItems(items); // reset filtered list
    }
  }, [items, fuseKeys]);

  // Handle dropdown toggle
  const handleDropToggle = () => {
    setDropOpen((prev) => !prev);
  };

  // Fuzzy search
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (fuseInstance && value.trim()) {
      const results = fuseInstance.search(value).map((result) => result.item);
      setFilteredItems(results);
    } else {
      setFilteredItems(items);
    }
  };

  // Click outside to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`dropdown search-drop ${assigned && assigned.length > 0 ? "drop2" : ""} ${
        dropOpen ? "active" : ""
      }`}
      style={style}
    >
      <div className="select" onClick={handleDropToggle}>
        <div className="d-flex align-items-center overflow-hidden">
          {assigned && assigned.length > 0 ? (
            assigned.map((item, index) => (
              <span
                key={index}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  marginRight: "8px",
                  backgroundColor: "#f0f0f0",
                  padding: "4px 8px",
                  borderRadius: "4px",
                }}
              >
                {item[labelKey]}
              </span>
            ))
          ) : (
            <span style={{ color: "#888" }}>{title}</span>
          )}
        </div>
        <i className="fa-solid fa-angle-up"></i>
      </div>
      <ul>
        <div className="drop-input">
          <IoSearch />
          <input
            type="text"
            placeholder={placeholder}
            ref={searchInputRef}
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
        <div className="list">
          {filteredItems && filteredItems.length > 0 ? (
            filteredItems.map((item, index) => {
              const isChecked = assigned.length > 0 && assigned.some(
                (assignedItem) => assignedItem[labelKey] === item[labelKey]
              );
              return (
                <li key={index}>
                  <label
                    htmlFor={`${idPrefix}-${index}`}
                    className="d-flex align-items-center"
                    style={{ gap: "10px", cursor: "pointer" }}
                  >
                    <input
                      type="checkbox"
                      id={`${idPrefix}-${index}`}
                      checked={isChecked}
                      onChange={() =>
                        assignedDrop(
                          item,
                          isChecked ? "remove" : "add"
                        )
                      }
                    />
                    <span>{item[labelKey]}</span>
                  </label>
                </li>
              );
            })
          ) : (
            <div
              style={{ padding: "8px", color: "#888" }}
              className="d-flex align-items-center justify-content-center h-100 w-100"
            >
              No results found
            </div>
          )}
        </div>
      </ul>
    </div>
  );
};

export default Dropdown;
